import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107')
];

export const server_loads = [];

export const dictionary = {
		"/": [25],
		"/about-us": [71],
		"/affiliate": [72],
		"/aml-policy": [73],
		"/betfeed": [74],
		"/blog": [75],
		"/bonus-terms": [76],
		"/calendar": [77],
		"/casino": [78],
		"/complaints-and-arbitration": [79],
		"/fairness": [80],
		"/game/[game]": [81,[17]],
		"/kyc-policy": [82],
		"/leaderboard": [83],
		"/originals": [84],
		"/originals/[game]": [85,[18]],
		"/payment-policy": [88],
		"/privacy-policy": [89],
		"/promotion-page": [90],
		"/promotion-page/race/[...id]": [92,[22]],
		"/promotion-page/[...id]": [91,[21]],
		"/providers": [93],
		"/p/[provider]": [86,[19]],
		"/p/[provider]/[game]": [87,[19,20]],
		"/races/current": [95],
		"/races/last": [96],
		"/races/next": [97],
		"/races/[raceId]": [94],
		"/referral": [98],
		"/responsible-gaming": [99],
		"/special-bets": [101],
		"/special": [100,[23]],
		"/sports": [102],
		"/sports/[...slug]": [103,[24]],
		"/terms-of-service": [104],
		"/terms-sports": [105],
		"/tournaments": [106],
		"/vip": [107],
		"/[provider=provider]": [69,[15]],
		"/[lang=lang]": [28,[3]],
		"/[category=category]": [27,[2]],
		"/[lang=lang]/about-us": [33,[3]],
		"/[lang=lang]/affiliate": [34,[3]],
		"/[lang=lang]/aml-policy": [35,[3]],
		"/[lang=lang]/betfeed": [36,[3]],
		"/[lang=lang]/blog": [37,[3]],
		"/[lang=lang]/bonus-terms": [38,[3]],
		"/[lang=lang]/calendar": [39,[3]],
		"/[lang=lang]/casino": [40,[3]],
		"/[lang=lang]/complaints-and-arbitration": [41,[3]],
		"/[lang=lang]/fairness": [42,[3]],
		"/[lang=lang]/game/[game]": [43,[3,7]],
		"/[lang=lang]/kyc-policy": [44,[3]],
		"/[lang=lang]/leaderboard": [45,[3]],
		"/[lang=lang]/originals": [46,[3]],
		"/[lang=lang]/originals/[game]": [47,[3,8]],
		"/[lang=lang]/payment-policy": [50,[3]],
		"/[lang=lang]/privacy-policy": [51,[3]],
		"/[lang=lang]/promotion-page": [52,[3]],
		"/[lang=lang]/promotion-page/race/[...id]": [54,[3,12]],
		"/[lang=lang]/promotion-page/[...id]": [53,[3,11]],
		"/[lang=lang]/providers": [55,[3]],
		"/[lang=lang]/p/[provider]": [48,[3,9]],
		"/[lang=lang]/p/[provider]/[game]": [49,[3,9,10]],
		"/[lang=lang]/races/current": [57,[3]],
		"/[lang=lang]/races/last": [58,[3]],
		"/[lang=lang]/races/next": [59,[3]],
		"/[lang=lang]/races/[raceId]": [56,[3]],
		"/[lang=lang]/referral": [60,[3]],
		"/[lang=lang]/responsible-gaming": [61,[3]],
		"/[lang=lang]/special-bets": [63,[3]],
		"/[lang=lang]/special": [62,[3,13]],
		"/[lang=lang]/sports": [64,[3]],
		"/[lang=lang]/sports/[...slug]": [65,[3,14]],
		"/[lang=lang]/terms-of-service": [66,[3]],
		"/[lang=lang]/tournaments": [67,[3]],
		"/[lang=lang]/vip": [68,[3]],
		"/[lang=lang]/[provider=provider]": [31,[3,5]],
		"/[lang=lang]/[category=category]": [30,[3,4]],
		"/[lang=lang]/[provider=provider]/[game]": [32,[3,5,6]],
		"/[provider=provider]/[game]": [70,[15,16]],
		"/[lang=lang]/[...fallback]": [29,[3]],
		"/[...fallback]": [26]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';